import Button from 'content-components/_Primatives/Button'
import Loader from 'content-components/_Primatives/Loader'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type Props = {
  children: React.ReactNode
  noResultsFoundText: string
  loadMoreText: string
  isLoading: boolean
  onLoadMore?: () => void
}

function DailyItemList(props: Props) {
  const {
    children,
    isLoading,
    onLoadMore,
    loadMoreText,
    noResultsFoundText,
  } = props

  return (
    <div className={style.wrapper}>
      {children}

      {onLoadMore && (
        <div className={style.buttonWrapper}>
          <Button
            className={style.button}
            variant='primaryBlue'
            onClick={onLoadMore}
          >
            {loadMoreText}
          </Button>
        </div>
      )}

      {isLoading && <Loader />}

      {!children && !isLoading && <Paragraph>{noResultsFoundText}</Paragraph>}
    </div>
  )
}

export default DailyItemList
